import { render, staticRenderFns } from "./webzine-magazine-article.vue?vue&type=template&id=44bc517b&scoped=true"
import script from "./webzine-magazine-article.vue?vue&type=script&lang=js"
export * from "./webzine-magazine-article.vue?vue&type=script&lang=js"
import style0 from "./webzine-magazine-article.vue?vue&type=style&index=0&id=44bc517b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bc517b",
  null
  
)

export default component.exports